import React from "react";
import "./AccessDenied.css";
import Searchnav from "./Searchnav";
import mailData from "../data/mailData";
function AccessDenied({ loggedInEnterpriseId, finalUsername }) {
  return (
    <>
      <Searchnav />
      <hr />
      <div className="error-text">
        <img
          src="images/AccessDenied/denied-img.png"
          alt="access-denied"
          className="denied-img"
        />
        <h1>OOOH!, ACCESS DENIED</h1>
        <p>
          You don't have permission to access this microsite. <br />
          Please reach out to{" "}
          <a
            href={`mailto:${mailData.LKM_TalentAcademy_Team_mail}?subject=Request%20Access%20to%20ABC%20Talent%20Academy&body=Hi%20Team%2C%0A%20%0APlease%20provide%20me%20the%20access%20to%20ABC%20Talent%20Academy%20(https%3A%2F%2Fatci.abctalentacademy.accenture.com%2F).%0A%0AEnt%20id%3A%20%3CEnter%20the%20Enterprise%20id%3E%0APurpose%3A%20%3C%20Explain%20why%20you%20need%20to%20access%3E%0AMarket%3A%20%3CEnter%20your%20Market%20name%3E%0ADU%3A%20%3C%20Provide%20your%20DU%20name%3E%0A%0ARegards%2C%0A${finalUsername}`}
          >
            {mailData.LKM_TalentAcademy_Team_mail}
          </a>{" "}
          for access.
        </p>
      </div>
    </>
  );
}

export default AccessDenied;
